import React from 'react';
import {useAuth} from '../hooks/useAuth';
import {isProviderOrOrganizationUser} from '../utils/tokenUtils';
import ProviderSingleResult from './ProviderSingleResult';
import PatientSingleResult from './PatientSingleResult';

const SingleResult: React.FC = () => {
    const {user, token} = useAuth();
    const jwt = token || user?.token;
    const isProviderOrOrgUser = Boolean(jwt && isProviderOrOrganizationUser(jwt));
    return isProviderOrOrgUser ? <ProviderSingleResult /> : <PatientSingleResult />;
};

export default SingleResult;
